import LocalizedStrings from "react-localization";

export const actionButtonsStrings = new LocalizedStrings({
  en: {
    brand: "Brand",
    reseller: "Reseller",
    exclude: "Exclude",
    errors: {
      LinesNotLockedByUser: "The selected lines have not been locked",
    },
  },
  fr: {
    brand: "Brand",
    reseller: "Reseller",
    exclude: "Exclure",
    errors: {
      LinesNotLockedByUser:
        "Les lignes sélectionnées n'ont pas été verrouillées",
    },
  },
});
